<template>
  <div class="login-container">
    <!-- 续费弹窗 -->
    <transition name="fade">
      <div v-if="showRenewModal" class="renew-modal-mask">
        <div class="renew-modal">
          <div class="renew-title">温馨提示</div>
          <div class="renew-content">
            <p>尊敬的校区负责人：</p>
            <p style="text-indent:2em;">感谢您长期以来对学堂的信任与支持！您的合作合同即将于<span class="renew-date"> {{ userInfo.contract_expire_time }} </span>到期。为确保不影响贵校后台订单管理系统的使用，请校区提前安排续约相关事宜。并于合同到期前与校区运营中心联系！谢谢！</p>
          </div>
          <div class="renew-footer">
            <el-button type="primary" :disabled="renewBtnDisabled" @click="closeRenewModal"  >我知道了<span v-if="renewBtnDisabled">（{{renewBtnTimer}}s）</span></el-button>
          </div>
        </div>
      </div>
    </transition>
      <div class="head-top">
        <div class="head-box">
          <img src="https://al3.acc5.com/179227_62bbc308af87c0.png"><b>数据中心首页</b>
          <span class="wx-bd-info">
            <img src="https://al3.acc5.com/179227_62eb2d891616a0.png" width="26" style="vertical-align: -6px;margin-right: 5px;" title="企业微信">
            <template v-if="userInfo.work_info && userInfo.work_info.userid">
              <span>已绑定 <img :src="userInfo.work_info.avatar" style="margin-left: 30px;margin-right: 5px;width: 30px;height: 30px;border-radius: 4px;"> {{userInfo.work_info.name}}<span v-if="userInfo.work_info.alias">({{userInfo.work_info.alias}})</span></span> <!-- <el-button size="mini" type="danger" @click="unBindWxWork">解绑企业微信</el-button> -->
            </template>
            <template v-else>
              <span>未绑定 </span><el-button size="mini" type="primary" @click="openBindWxWork">绑定企业微信</el-button>
            </template>
            <el-popover placement="bottom" trigger="click">
              <div>
                <p v-for="(item, index) in userInfo.wechat_users"><img width="30" :src="item.head_img_url"> <el-tag v-if="item.is_sharer" effect="dark" size="small">分享员</el-tag> <span class="popover-user-name">{{item.nickname}} </span><el-button size="mini" type="danger" icon="el-icon-delete" @click="unBindWeixin(item.id,item.nickname)">解绑该微信</el-button></p>
                <p style="text-align:center;"><el-button size="mini" type="success" @click="openBindWeixin" class="btn-bdwx" icon="el-icon-plus">绑定新的微信</el-button></p>
              </div>
              <el-button slot="reference" size="mini" type="success" class="btn-bdwx ml">{{userInfo.wechat_users && userInfo.wechat_users.length > 0 ? "已绑定"+userInfo.wechat_users.length+"个微信":"绑定微信"}}</el-button>
            </el-popover>
          </span>
          <el-dropdown placement="bottom" @command="handleCommand">
            <span class="el-dropdown-link">
              <img :src="userInfo.head_url" class="avatar">{{userInfo.name}}<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>首页</el-dropdown-item>
              <el-dropdown-item command="toCenter">个人中心</el-dropdown-item>
              <el-dropdown-item command="unBind" v-if="userInfo.work_info && userInfo.work_info.userid">解绑企业微信</el-dropdown-item>
              <!-- <el-dropdown-item>常见问题</el-dropdown-item>
              <el-dropdown-item command="feedback">意见反馈</el-dropdown-item> -->
              <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="data-container">
        <template v-if="isCom">
          <div class="item box-transition" @click="toLink(1)" title="资源分配+数据详情">
            <img src="https://al3.acc5.com/179227_62bbcc42170cc0.png">
            <p>聚宝盆</p>
          </div><div class="item box-transition" @click="toLink(2)" title="学员开号+订单详情">
            <img src="https://al3.acc5.com/179227_62bbcc41eafd70.png">
            <p>订单中心</p>
          </div><div class="item box-transition" @click="toLink(3)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>教务系统</p>
          </div><div v-if="userInfo.has_wwwacc5_admin" class="item box-transition" @click="toLink(13)" title="系统后台管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>系统后台</p>
          </div><div v-if="false" class="item box-transition" @click="toLink(14)" title="营销人员后台">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>营销后台</p>
          </div>
          <div style="display: none;" class="item box-transition" @click="toLink(7)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（本地）聚宝盆</p>
          </div><div style="display: none;" class="item box-transition" @click="toLink(8)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（本地）订单中心</p>
          </div><div style="display: none;" class="item box-transition" @click="toLink(9)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（本地）教务系统</p>
          </div>
          <img src="https://al3.acc5.com/179227_67ee038b740c80.jpg" v-if="userInfo.is_offline" width="1032">
        </template>
        <template v-else>
          <div class="item box-transition" @click="toLink(4)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（测试）聚宝盆</p>
          </div><div class="item box-transition" @click="toLink(5)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（测试）订单中心</p>
          </div><div class="item box-transition" @click="toLink(6)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（测试）教务系统</p>
          </div>
          <div v-if="userInfo.has_wwwacc5_admin" class="item box-transition" @click="toLink(15)" title="系统后台管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（测试）系统后台</p>
          </div><div v-if="false" class="item box-transition" @click="toLink(16)" title="营销人员后台">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（测试）营销后台</p>
          </div>
          <div class="item box-transition" @click="toLink(10)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（预发布）聚宝盆</p>
          </div><div class="item box-transition" @click="toLink(11)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（预发布）订单中心</p>
          </div><div class="item box-transition" @click="toLink(12)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（预发布）教务系统</p>
          </div>
          <div class="item box-transition" @click="toLink(7)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（本地）聚宝盆</p>
          </div><div class="item box-transition" @click="toLink(8)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（本地）订单中心</p>
          </div><div class="item box-transition" @click="toLink(9)" title="教务教学+校区管理">
            <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
            <p>（本地）教务系统</p>
          </div>
        </template>
        <!-- <div class="item box-transition" @click="toLink(4)" title="教务教学+校区管理">
          <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
          <p>本地9528</p>
        </div><div class="item box-transition" @click="toLink(5)" title="教务教学+校区管理">
          <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
          <p>本地8080</p>
        </div><div class="item box-transition" @click="toLink(6)" title="教务教学+校区管理">
          <img src="https://al3.acc5.com/179227_62bbcc41ddd980.png">
          <p>192.168.31.2:9528</p>
        </div> -->
      </div>
  </div>
</template>
<script>
import { getUserInfo,doLoginOut,get_bind_wx_work,un_bind_wx_work,get_bind_weixin,un_bind_weixin } from "@/api/user";
export default {
  data() {
    return {
      loading: false,
      userInfo:{},
      isCom:location.href.includes('sso.acc5.com'),
      showRenewModal: false,
      // 续费弹窗相关数据
      renewBtnDisabled: true,
      renewBtnTimer: 20,
      renewTimer: null,
    }
  },
  created () {
    getUserInfo().then(res => {
      if (res.code === 200) {
        this.userInfo = res.data
        console.log(this.userInfo)
        if(this.userInfo.contract_expire_time){
          const expire = new Date(this.userInfo.contract_expire_time.replace(/-/g, '/'));
          const now = new Date();
          const diff = expire.getTime() - now.getTime();
          const days = diff / (1000 * 60 * 60 * 24);
          if (days <= 7) {
            this.openRenewModal();
          }
        }
        if (this.$route.query.opwxwork && this.$route.query.opwxwork == 1) {
            this.$router.replace({query:{}})
            this.openBindWxWork()
        }
      }
    })
    if (this.$route.query.code && this.$route.query.code == 200) {
        this.$router.replace({query:{}})
        this.$message({message: '绑定企业微信成功',type: "success"});
    }
    if (this.$route.query.error_msg) {
      this.$alert(this.$route.query.error_msg, '温馨提示', {type: "error",confirmButtonText: '我知道了',showClose:false,lockScroll:false,callback: action => {
        this.$router.replace({query:{}})
      }});
    }
  },
  mounted () {
    if(document.getElementsByClassName('item').length > 6){
      document.getElementsByClassName('data-container')[0].style.paddingTop = '50px'
    }
  },
  methods: {
    openRenewModal() {
      // 续费弹窗倒计时逻辑
      this.showRenewModal = true;
      this.renewBtnDisabled = true;
      this.renewBtnTimer = 20;
      this.renewTimer = setInterval(() => {
        if (this.renewBtnTimer > 1) {
          this.renewBtnTimer--;
        } else {
          this.renewBtnDisabled = false;
          clearInterval(this.renewTimer);
        }
      }, 1000);
    },
    // 关闭续费弹窗
    closeRenewModal() {
      this.showRenewModal = false;
      if (this.renewTimer) clearInterval(this.renewTimer);
    },
    toLink(e){
      let urlStr = ""
      if(e == 1){
        urlStr = "https://youqian.acc5.com/nhtml/#/login"
      }else if(e == 2){
        urlStr = "https://data.acc5.com/#/login"
      }else if(e == 3){
        urlStr = "https://dc.acc5.com/education/#/login"
      }else if(e == 4){
        urlStr = "https://youqianacc5.kjxt.com/nhtml/#/login"
      }else if(e == 5){
        urlStr = "https://data.kjxt.com/#/login"
      }else if(e == 6){
        urlStr = "https://dcacc5.kjxt.com/education/#/login"
      }else if(e == 7){
        urlStr = "http://localhost:9529/#/login"
      }else if(e == 8){
        urlStr = "http://localhost:9528/#/login"
      }else if(e == 9){
        urlStr = "http://localhost:8080/#/login"
      }else if(e == 10){
        urlStr = "https://youqian2.acc5.com/nhtml/#/login"
      }else if(e == 11){
        urlStr = "https://data2.acc5.com/#/login"
      }else if(e == 12){
        urlStr = "https://dc2.acc5.com/education/#/login"
      }else if(e == 13){
        urlStr = "https://admin.acc5.com/admincp.php?c=sso_login"
      }else if(e == 14){
        urlStr = "https://admin.acc5.com/manage.php?c=sso_login"
      }else if(e == 15){
        urlStr = "https://wwwacc5.kjxt.com/admincp.php?c=sso_login"
      }else if(e == 16){
        urlStr = "https://wwwacc5.kjxt.com/manage.php?c=sso_login"
      }
      console.log(urlStr+'?access_token=' + encodeURIComponent(localStorage.getItem('access_token')))
      if(e == 13 || e == 14 || e == 15 || e == 16){
        window.open(urlStr+'&access_token=' + encodeURIComponent(localStorage.getItem('access_token')))
      }else{
        window.open(urlStr+'?access_token=' + encodeURIComponent(localStorage.getItem('access_token')))
      }
    },
    handleCommand(e){
      if(e == "loginOut"){
        doLoginOut({admin_id:this.userInfo.id}).then(res => {
          if (res.code === 200) {
            localStorage.removeItem('access_token');
            this.$message({message: '退出成功',type: 'success'});
            this.$router.push('/login')
          }else{
            this.$message({message: res.message,type: 'error'});
          }
        })
      }else if(e == "toCenter"){
        window.open('https://youqian.acc5.com/nhtml/#/personal_center/essential_information')
      }else if(e == "unBind"){
        this.unBindWxWork()
      }
    },
    openBindWeixin(){
      get_bind_weixin({admin_id:this.userInfo.id}).then(res=>{
        if(res.code==200){
          this.$alert('<div style="text-align: center;"><img src="'+res.data.url+'" width="280" ></div>', '绑定微信', {
            dangerouslyUseHTMLString: true,
            lockScroll:false,
            showConfirmButton:false
          }).catch(action => {
            clearInterval(weixinInter);
          });
          let weixinInter;
          let keyStr = res.data.key
          weixinInter = setInterval(() => {
           get_bind_weixin({admin_id:this.userInfo.id,key:keyStr}).then(res=>{
              if(res.code==200){
                this.$message({message: "扫码成功",type: "success",duration:1500,onClose:function(){
                  location.reload()
                }});
              }else{
                if(res.code!=400){
                  this.$message.error(res.message);
                }
              }
            })
          }, 3000);
        }else{
          this.$message.error(res.message);
        }
      })
    },
    openBindWxWork(){
      get_bind_wx_work({id:this.userInfo.id}).then(res=>{
        if(res.code==200){
          this.$alert('<iframe src="'+res.data+'" frameborder="0" style="width: 380px;height: 380px;"></iframe>', '绑定企业微信', {
            dangerouslyUseHTMLString: true,
            lockScroll:false,
            showConfirmButton:false
          });
        }else{
          this.$message.error(res.message);
        }
      })
    },
    unBindWxWork(){
      this.$confirm('确定要解除绑定企业微信？', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        lockScroll:false,
        type: 'warning'
      }).then(() => {
        un_bind_wx_work({id:this.userInfo.id}).then(res=>{
          if(res.code==200){
            this.$message({message: res.message,type: "success",duration:800,onClose:function(){
              location.reload()
            }});
          }else{
            this.$message.error(res.message);
          }
        })
      })
    },
    unBindWeixin(rid,rname){
      this.$confirm('确定要解除绑定微信 '+rname+'？', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        lockScroll:false,
        type: 'warning'
      }).then(() => {
        un_bind_weixin({admin_id:this.userInfo.id,id:rid}).then(res=>{
          if(res.code==200){
            this.$message({message: res.message,type: "success",duration:800,onClose:function(){
              location.reload()
            }});
          }else{
            this.$message.error(res.message);
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.renew-modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}
.renew-modal {
  background: #fff;
  border-radius: 16px;
  width: 420px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.18);
  padding: 32px 28px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: popIn .3s;
}
.renew-title {
  font-size: 22px;
  font-weight: bold;
  color: #ff9800;
  margin-bottom: 18px;
}
.renew-content {
  line-height: 28px;
  font-size: 16px;
  color: #333;
  margin-bottom: 28px;
  text-align: left;
  width: 100%;
}
.renew-date {
  color: #e91e63;
  font-weight: bold;
}
.renew-footer {
  width: 100%;
}
@keyframes popIn {
  0% { transform: scale(0.7); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.box-transition{-webkit-transition: all .25s linear 0s; transition: all .25s linear 0s;}
img{vertical-align: middle;}
.login-container{position: absolute;left: 0;bottom: 0;top: 0;right: 0; background-image: url(https://al3.acc5.com/179227_62bbc20a825230.png);background-size: cover;}
.head-top{z-index: 2;position: absolute;left: 0;top: 0;width: 100%; background-color: #001529;text-align: left;color: #fff;}
.head-top b{margin-left: 10px;font-size: 16px;}
.head-top .head-box{padding-left: 25px;padding-right: 25px;line-height: 64px;}
.head-top .avatar{width: 40px;height: 40px;margin-right: 10px;border-radius: 4px;}
.head-top .el-dropdown{float: right;cursor: pointer;color: #fff;}
.data-container{width: 1200px;margin: 0 auto;padding-top: 130px;}
.data-container .item{display: inline-block; width: 308px;height: 220px;margin:30px; background-image: url(https://al3.acc5.com/179227_62bbcb511c9b00.png);cursor: pointer;color: #fff;font-size: 22px;}
.data-container .item:hover{-webkit-transform: translateY(-10px);transform: translateY(-10px);}
.data-container .item img{margin-top: 25px;}
.wx-bd-info{position: absolute;left: 50%;top:0;transform: translateX(-50%);}
.btn-bdwx{background-color:#1AAD19;border-color:#1AAD19;}
.btn-bdwx.ml{margin-left:30px;}
.popover-user-name{display:inline-block;width:140px;}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue